// Business survey
export const WORK_FREQUENCY_QUESTION_ID = "6";
export const BUY_FREQUENCY_QUESTION_ID = "7";
export const LICENSE_QUESTION_ID = "8";
export const PERMIT_QUESTION_ID = "9";

export const LICENSE_YES_ANSWER_ID = "466";

// Member survey
export const MEMBER_QUESTION_ID = "12";
